<template>
  <div>
    <van-popup
      v-model="isShow"
      position="bottom"
      :close-on-popstate="true"
      round
      :style="{
        height: height
      }"
      class="kf_content"
    >
      <div
        v-if="phone"
        class="font18"
        style="padding: 0.3rem;line-height: 1.5;"
      >
        {{ $t('A134','统一对外联系电话') }}：
        <br>
        <a
          class="main-color"
          :href="`${'tel:' + phone}`"
        >{{ phone }}</a>
      </div>
      <van-tabs
        v-else
        v-model="active"
        line-width="20px"
        line-height="2px"
        animated
        swipeable
        sticky
      >
        <van-tab
          v-for="(kf_item,index) in list"
          :key="index"
          :title="kf_item.productTypeName"
          :name="kf_item.productType"
        >
          <van-row
            v-for="(user, j) in kf_item.userList"
            :key="j"
            type="flex"
            align="center"
            class="kf_list"
          >
            <van-col
              class="text-center"
              span="4"
            >
              <ld-icon
                class="main-color"
                size="28"
                :type="kf_item.productType | icon"
              />
            </van-col>
            <van-col
              :class="{ 'van-hairline--bottom': j === kf_item.userList.length }"
              span="14"
            >
              <div class="font16 black font-md">
                {{ user.userName }}
              </div>
              <div class="font12">
                {{ user.phone }}
              </div>
            </van-col>
            <van-col span="6">
              <div
                class="call bg-main fr white text-center"
                @click="call(user.phone)"
              >
                <a
                  class="font12 white"
                  :href="`${'tel:'+user.phone}`"
                >{{ $t('B051','呼叫') }}</a>
              </div>
            </van-col>
          </van-row>
        </van-tab>
      </van-tabs>
    </van-popup>
  </div>
</template>

<script>
import { Popup, Tabs, Tab } from 'vant'
import { mapGetters, mapActions,mapState } from 'vuex'
import orderMixin from '@/business/views/Home/allorder/components/orderMixin'

export default {
  name: 'ServiceList',
  mixins: [orderMixin],
  components: {
    [Popup.name]: Popup,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab
  },
  data() {
    return {
      isShow: false,
      active: $dict.PRO_TYPE.tk,
      list:[],
      phone: '',
    }
  },
  props: {
    height: {
      type: String,
      default: '50%'
    },
    visibility: {
      type: Boolean,
      default: false
    }
  },
  async created () {
    // 获取服务组电话

    // 2021年3月3日 —— 首页客服电话，如果有设置统一电话，则展示统一电话。若未设置取服务组电话。
    let { data = {} } = await this.$api['common/getSysParameter']({
      paramNo: '11605007'
    })

    if (data.value1) {
      this.phone = data.value1
    } else {
      this.getCustomerInfoList()
    }
  },
  methods: {
    ...mapActions(['getCustomerInfoList']),
    call (telNum) {
      console.log('拨打电话' + telNum)
    },
    getList(){
      if(this.serverList&&this.serverList.length>0){
        let list = []
        const MergeProType = [
          [$dict.PRO_TYPE.tk, $dict.PRO_TYPE.tkIntel],
          [$dict.PRO_TYPE.hotel, $dict.PRO_TYPE.tkIntelHotel],
          [$dict.PRO_TYPE.tr], [$dict.PRO_TYPE.car]
        ]
        for (let i = 0; i < MergeProType.length; i++) {
          let Merge = MergeProType[i], child_list = []
          for (let j = 0; j < Merge.length; j++) {
            child_list.push(...this.serverList.filter(item => item.productType === Merge[j]))
          }
          child_list.forEach((val, i) => {
            if (i > 0) {
              val.userList.forEach(src_user => {
                child_list[0].userList.push(src_user)
                child_list[0].userList = child_list[0].userList.filter((element, index, self) => {
                  return self.findIndex(el => el['userName'] == element['userName']) === index
                })
              })
            }
          })
          if (child_list[0]&&(child_list[0].productType == '10901')) {
            child_list[0].productTypeName = '机票'
          }
          if(child_list[0]){
            list.push(child_list[0])
          }
        }
        const OPEN_PRO_TYPES = this.authorizationPnosMap.map(i => i.productNo)
        list.forEach((menu, index) => {
          if (!OPEN_PRO_TYPES.includes(menu.productType)) {
            list.splice(index, 1)
          }
        })
        this.list = list
      }
    }
  },
  computed: {
    ...mapGetters(['serverList', 'userInfo']),
    ...mapState({
      authorizationPnosMap: state => state.app.authorizationPnosMap,
    })
  },
  watch: {
    'serverList.length'(){
      this.getList()
    },
    visibility (val) {
      this.isShow = val
      if (val) this.getList()
    },
    isShow (val) {
      this.$emit('update:visibility', val)
    }
  }
}
</script>

<style lang="less">
.kf_content {
  background: #fff;
  color: @color-text-black;

  .info {
    p {
      color: @color-text-gray
    }
  }
  .call {
    width: 52px;
    height: 26px;
    line-height: 26px;
    margin: 24px 15px;
    background-blend-mode: normal, normal;
    box-shadow: 0px 4px 4px 0px rgba(211, 163, 94, 0.3);
    border-radius: 26px;
    text-align: center;
  }
}
</style>
